import { render, staticRenderFns } from "./CheckInactivity.vue?vue&type=template&id=f6cfe748"
import script from "./CheckInactivity.vue?vue&type=script&lang=js"
export * from "./CheckInactivity.vue?vue&type=script&lang=js"
import style0 from "./CheckInactivity.vue?vue&type=style&index=0&id=f6cfe748&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports